'use client';

import { forwardRef } from 'react';
import { useIntl } from 'react-intl';

import { IconSearch } from '../../../../design-system/components/icons/Search';
import { Typography } from '../../../../design-system/components/typography/Typography';

import style from './MobileMenuSearchInput.module.css';

type Props = {
    onClick: () => void;
};

export const MobileMenuSearchInput = forwardRef<HTMLButtonElement, Props>(
    function MobileMenuSearchInput({ onClick }, ref) {
        const { formatMessage } = useIntl();

        return (
            <button ref={ref} type="button" className={style.trigger} onClick={onClick}>
                <span className={style.iconWrapper}>
                    <IconSearch className={style.icon} />
                </span>
                <Typography scale="primary-body-regular" className={style.placeholder}>
                    {formatMessage({ id: 'page.home.searchPlaceholder' })}
                </Typography>
            </button>
        );
    },
);
